import React, { useEffect, useMemo, useState } from "react";
import { PricingDetails } from "./PricingDetails";
import { useUserStripeData } from "hooks/useUserStripeData";
import { StripeConnectWrapper } from "components/stripe/StripeConnectWrapper";
import { useCombineLoading } from "hooks/useCombineLoading";

/**
 * A section of the Gated Content page that displays the Stripe section.
 */
export const GatedContentPageStripeSection = () => {
    const {
        accountData: { account, details },
        productData: { products, getProducts },
        loading: stripeLoading
    } = useUserStripeData({
        requestImmediately: true,
        includeProducts: true
    });

    // Start with loading=true until we can confirm data is ready
    const [localLoading, setLocalLoading] = useState(true);

    useEffect(() => {
        if (!stripeLoading && products !== undefined) {
            setLocalLoading(false);
        }
    }, [stripeLoading, products]);

    const pageLoading = useCombineLoading(stripeLoading, localLoading);

    const nonCatalogProducts = useMemo(
        () =>
            products?.filter(
                (p) =>
                    p.CreatorProductEntitlements.length === 0 ||
                    // @ts-expect-error - Handle multiple types
                    p.CreatorProductEntitlements.some((cpe) => !cpe.CatalogId)
            ),
        [products]
    );

    return (
        <div>
            <StripeConnectWrapper inlineLoading={false}>
                <PricingDetails
                    account={account}
                    loading={pageLoading}
                    products={nonCatalogProducts}
                    getProducts={getProducts}
                    details={details}
                    setLoading={setLocalLoading}
                />
            </StripeConnectWrapper>
        </div>
    );
};
